import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as c } from "react";
import { I as o } from "../../../../IconBase-CxZyIWw2.js";
const t = c((e, a) => /* @__PURE__ */ s.jsx(
  o,
  {
    ref: a,
    ...e,
    image: (r) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...r,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_4109",
              width: 17,
              height: 25,
              x: 16,
              y: 12,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  fill: "currentColor",
                  d: "M32.11 20.05c0-4.44-3.61-8.05-8.05-8.05S16 15.61 16 20.05c0 4.19 3.21 7.64 7.31 8.02v3.36h-2.3c-.41 0-.75.34-.75.75s.34.75.75.75h2.29v2.38c0 .41.34.75.75.75s.75-.34.75-.75v-2.38h2.29c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-2.28v-3.36c4.09-.38 7.3-3.83 7.3-8.02m-14.61 0c0-3.61 2.94-6.55 6.56-6.55a6.56 6.56 0 0 1 6.55 6.55c0 3.62-2.94 6.56-6.55 6.56-3.62 0-6.56-2.94-6.56-6.56"
                }
              )
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_4109)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M1.299 1.261h46.21v46.21H1.298z" }) })
        ]
      }
    )
  }
));
t.displayName = "AgencyFemaleIcon";
export {
  t as AgencyFemaleIcon,
  t as default
};
//# sourceMappingURL=index.js.map
